
// Autogenerated - Please don't edit or remove
// This file is auto-generated by internals/generateBlogpostsData.js
// It exports a json with blog post paths as keys and the imported
// file path as data. It's being auto generated as part of webpack.base.config.js
// each time from scratch based on the contents of the app/blog-posts directory's
// json contents.
// The data is used to generate sitemap in sitemap.js and to dynamically import
// blog posts in app/services/Pip/endpoints/Content.js

module.exports = {
  "/4-reasons-transfer-isa": {
    "dynamicImport": () => import('blog-posts/4-reasons-transfer-isa.md')
  },
  "/6-things-british-pearl-ifisa": {
    "dynamicImport": () => import('blog-posts/6-things-british-pearl-ifisa.md')
  },
  "/Portsmouth-1-sold-out-what-happens-next": {
    "dynamicImport": () => import('blog-posts/Portsmouth-1-sold-out-what-happens-next.md')
  },
  "/benefits-of-the-british-pearl-ifisa": {
    "dynamicImport": () => import('blog-posts/benefits-of-the-british-pearl-ifisa.md')
  },
  "/british-pearls-top-sharing-economy-companies": {
    "dynamicImport": () => import('blog-posts/british-pearls-top-sharing-economy-companies.md')
  },
  "/comparing-p2p-crowdinvesting-options": {
    "dynamicImport": () => import('blog-posts/comparing-p2p-crowdinvesting-options.md')
  },
  "/demand-for-rented-homes-expected-to-reach-6-million-by-2025": {
    "dynamicImport": () => import('blog-posts/demand-for-rented-homes-expected-to-reach-6-million-by-2025.md')
  },
  "/do-you-need-a-certain-career-to-join-the-property-ladder": {
    "dynamicImport": () => import('blog-posts/do-you-need-a-certain-career-to-join-the-property-ladder.md')
  },
  "/dont-forget-the-innovative-finance-isa": {
    "dynamicImport": () => import('blog-posts/dont-forget-the-innovative-finance-isa.md')
  },
  "/everyone-is-talking-about-brexit": {
    "dynamicImport": () => import('blog-posts/everyone-is-talking-about-brexit.md')
  },
  "/how-does-british-pearl-mitigate-risk": {
    "dynamicImport": () => import('blog-posts/how-does-british-pearl-mitigate-risk.md')
  },
  "/how-does-british-pearl-select-properties": {
    "dynamicImport": () => import('blog-posts/how-does-british-pearl-select-properties.md')
  },
  "/how-will-crossrail-affect-property-prices": {
    "dynamicImport": () => import('blog-posts/how-will-crossrail-affect-property-prices.md')
  },
  "/in-the-press": {
    "dynamicImport": () => import('blog-posts/in-the-press.md')
  },
  "/is-direct-property-investment-for-you": {
    "dynamicImport": () => import('blog-posts/is-direct-property-investment-for-you.md')
  },
  "/is-now-the-time-to-buy-uk-property": {
    "dynamicImport": () => import('blog-posts/is-now-the-time-to-buy-uk-property.md')
  },
  "/is-the-property-sector-ready-for-the-2020s": {
    "dynamicImport": () => import('blog-posts/is-the-property-sector-ready-for-the-2020s.md')
  },
  "/ltv-what-it-means": {
    "dynamicImport": () => import('blog-posts/ltv-what-it-means.md')
  },
  "/property-update-may-2019": {
    "dynamicImport": () => import('blog-posts/property-update-may-2019.md')
  },
  "/reasons-to-be-optimistic-about-buy-to-let": {
    "dynamicImport": () => import('blog-posts/reasons-to-be-optimistic-about-buy-to-let.md')
  },
  "/reasons-you-should-join-british-pearl": {
    "dynamicImport": () => import('blog-posts/reasons-you-should-join-british-pearl.md')
  },
  "/regulatory-compliance-british-pearl": {
    "dynamicImport": () => import('blog-posts/regulatory-compliance-british-pearl.md')
  },
  "/resale-market-introduction": {
    "dynamicImport": () => import('blog-posts/resale-market-introduction.md')
  },
  "/the-value-you-can-add-to-your-home-through-refurbishment": {
    "dynamicImport": () => import('blog-posts/the-value-you-can-add-to-your-home-through-refurbishment.md')
  },
  "/uks-housing-shortage-backlog-reaches-four-million": {
    "dynamicImport": () => import('blog-posts/uks-housing-shortage-backlog-reaches-four-million.md')
  },
  "/update-andover-sold-out": {
    "dynamicImport": () => import('blog-posts/update-andover-sold-out.md')
  },
  "/what-can-you-buy-for-100-pounds": {
    "dynamicImport": () => import('blog-posts/what-can-you-buy-for-100-pounds.md')
  },
  "/why-investors-use-british-pearl": {
    "dynamicImport": () => import('blog-posts/why-investors-use-british-pearl.md')
  },
  "/why-people-invest-in-british-pearl-loans": {
    "dynamicImport": () => import('blog-posts/why-people-invest-in-british-pearl-loans.md')
  },
  "/worldwide-trends-2018": {
    "dynamicImport": () => import('blog-posts/worldwide-trends-2018.md')
  }
}

